export default function (state = [], action={}) {
    switch (action.type) {
    case "GETUSERIMAGE_REQUESTED":
        return {
            ...state,
            // availableKasms: null,
            getuserimageLoading: true,
            getuserimageError: null
        };
    case "GETUSERIMAGE_SUCCESS":
        return {
            ...state,
            availableKasms: action.response.images,
            getuserimageLoading: false,
            getuserimageError: null,
        };
    case "GETUSERIMAGE_FAILED":
        return {
            ...state,
            availableKasms: null,
            getuserimageLoading: false,
            getuserimageError: action.response
        };

    case "GETUSERKASMS_REQUESTED":
        return {
            ...state,
            liveKasms: null,
            getuserkasmsLoading: true,
            getuserkasmsError: null
        };
    case "GETUSERKASMS_SUCCESS":
        return {
            ...state,
            liveKasms: action.response.kasms,
            getuserkasmsLoading: false,
            getuserkasmsError: null
        };
    case "GETUSERKASMS_FAILED":
        return {
            ...state,
            liveKasms: null,
            getuserkasmsLoading: false,
            getuserkasmsError: "Invalid Data"
        };

    case "GETSTATUSKASMS_REQUESTED":
        return {
            ...state,
            getstatuskasmsLoading: true,
            getstatuskasmsError: null
        };
    case "GETSTATUSKASMS_SUCCESS":
        if(action.response && action.response.error_message){
            return {
                ...state,
                errorStatusKasmsMessage: action.response.error_message,
                getstatuskasmsLoading: false,
                getstatuskasmsError: null
            };
        }
        else {
            return {
                ...state,
                statusKasms: action.response.kasm,
                errorStatusKasmsMessage:null,
                getstatuskasmsLoading: false,
                getstatuskasmsError: null
            };
        }
    case "GETSTATUSKASMS_FAILED":
        return {
            ...state,
            execKasmLoading: false,
            execKasmError: action.error && action.error.message
        };
    case "EXECKASM_REQUESTED":
        return {
            ...state,
            execKasmLoading: true,
            execKasmError: null
        };
    case "EXECKASM_SUCCESS":
        if(action.response && action.response.error_message){
            return {
                ...state,
                errorExecKasmMessage: action.response.error_message,
                execKasmLoading: false,
                execKasmError: null
            };
        }
        else {
            return {
                ...state,
                execKasm: action.response.kasm,
                errorExecKasmMessage:null,
                execKasmLoading: false,
                execKasmError: null
            };
        }
    case "EXECKASM_FAILED":
        return {
            ...state,
            execKasmLoading: false,
            execKasmsError: action.error && action.error.message
        };
    case "DESTORY_KASMS_REQUESTED":
        return {
            ...state,
            destorykasmsLoading: true,
            destorykasmsError: null
        };
    case "DESTORY_KASMS_SUCCESS":
        if (action.response && action.response.error_message) {
            return {
                ...state,
                destoryKasmsErrorMessage: action.response.error_message,
                destoryKasmsLoading: false,
                destoryKasmsError: null
            };
        } else{
            return {
                ...state,
                destoryKasmsErrorMessage: null,
                destoryKasmsLoading: false,
                destoryKasmsError: null
            };
        }
    case "DESTORY_KASMS_FAILED":
        return {
            ...state,
            destoryKasmsLoading: false,
            destoryKasmsError: action.error && action.error.message
        };

    case "CREATE_KASMS_REQUESTED":
        return {
            ...state,
            createKasmsLoading: true,
            createKasmsError: null
        };
    case "CREATE_KASMS_SUCCESS":  
        if(action.response && action.response.error_message){
            return {
                ...state,
                errorCreateMessage: action.response.error_message,
                errorCreateMessageDetail: action.response.error_detail,
                createKasmsLoading: false,
                createkasmsError: null
            };
        }
        else {
            return {
                ...state,
                createdKasms: action.response,
                errorCreateMessage: null,
                createKasmsLoading: false,
                createkasmsError: null
            };
        }
    case "CREATE_KASMS_FAILED":
        return {
            ...state,
            createkasmsLoading: false,
            createkasmsError: action.error && action.error.message
        };

    case "UPDATE_KEEPALIVE_REQUESTED":
        return {
            ...state,
            Update_keepaliveLoading: true,
            Update_keepaliveError: null
        };
    case "UPDATE_KEEPALIVE_SUCCESS":
        return {
            ...state,
            keepalive : action.response,
            Update_keepaliveLoading: false,
            Update_keepaliveError: null
        };
    case "UPDATE_KEEPALIVE_FAILED":
        return {
            ...state,
            Update_keepaliveLoading: false,
            Update_keepaliveError: action.error
        };

    case "GET_CLIENT_SETTINGS_REQUESTED":
        return {
            ...state,
            clientsettings: null,
            getClientSettingsLoading: true,
            getClientSettingsError: null
        };
    case "GET_CLIENT_SETTINGS_SUCCESS": 
        return {
            ...state,
            clientsettings: action.response,
            getClientSettingsLoading: false,
            getClientSettingsError: null
        };
    case "GET_CLIENT_SETTINGS_FAILED":
        return {
            ...state,
            clientsettings:  null,
            getClientSettingsLoading: false,
            getClientSettingsError: action.error
        };

    case "GET_DEFAULT_IMAGE_REQUESTED":
        return {
            ...state,
            userdefault: null,
            getUserDefaultLoading: true,
            getUserDefaultError: null
        };
    case "GET_DEFAULT_IMAGE_SUCCESS":
        return {
            ...state,
            userdefault: action.response,
            getUserDefaultLoading: false,
            getUserDefaultError: null
        };
    case "GET_DEFAULT_IMAGE_FAILED":
        return {
            ...state,
            userdefault:  null,
            getUserDefaultLoading: false,
            getUserDefaultError: action.error
        };

    case "CREATE_SHARE_ID_REQUESTED":
        return {
            ...state,
            share_id: null,
            createShareLoading: true,
            createShareError: null
        };
    case "CREATE_SHARE_ID_SUCCESS":
        return {
            ...state,
            share_id: action.response.share_id,
            createShareLoading: false,
            createShareError: action.response.error_message || null,
        };
    case "CREATE_SHARE_ID_FAILED":
        return {
            ...state,
            share_id:  null,
            createShareLoading: false,
            createShareError: action.error,
        };

    case "DESTROY_SHARE_ID_REQUESTED":
        return {
            ...state,
            share_id: null,
            destroyShareLoading: true,
            destroyShareError: null
        };
    case "DESTROY_SHARE_ID_SUCCESS":
        return {
            ...state,
            share_id: action.response.share_id,
            destroyShareLoading: false,
            destroyShareError: action.response.error_message || null
        };
    case "DESTROY_SHARE_ID_FAILED":
        return {
            ...state,
            share_id:  null,
            destroyShareLoading: false,
            destroyShareError: action.error
        };

    case "JOIN_KASM_REQUESTED":
        return {
            ...state,
            joinKasm: null,
            joinKasmLoading: true,
            joinKasmError: null
        };
    case "JOIN_KASM_SUCCESS":
        return {
            ...state,
            joinKasm: action.response.kasm,
            joinKasmLoading: false,
            joinKasmError: action.response.error_message || null
        };
    case "JOIN_KASM_FAILED":
        return {
            ...state,
            joinKasm:  null,
            joinKasmLoading: false,
            joinKasmError: action.error
        };

    case "GET_VIEWKASM_REQUESTED":
        return {
            ...state,
            viewedKasms: null,
            viewKasmsLoading: true
        };
    case "GET_VIEWKASM_SUCCESS":
        if (action.response.dead_kasms) {
            let joined_kasms = JSON.parse(window.localStorage.getItem("joined_kasms"));
            for (let dead of action.response.dead_kasms) {
                let index = joined_kasms.kasms.indexOf(dead);
                if (index !== -1) {
                    joined_kasms.kasms.splice(index, 1);
                    window.localStorage.setItem("joined_kasms", JSON.stringify(joined_kasms));
                }
            }
        }
        return {
            ...state,
            viewedKasms: action.response.viewed_kasms,
            viewKasmsLoading: false
        };
    case "GET_VIEWKASM_FAILED":
        return {
            ...state,
            viewedKasms:  null,
            viewKasmsLoading: false
        };

    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/models/dashboardReducer.js